import DOMPurify from 'dompurify';
import { arrayOf, node, string } from 'prop-types';
import React from 'react';

const DOMSanitizer = ({
  children,
  element: Element = 'div',
  addAttributes
}) => {
  if (!children) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Element, {
    className: "sanitized",
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(children, {
        ADD_ATTR: addAttributes
      })
    }
  });
};

DOMSanitizer.defaultProps = {
  children: undefined,
  element: 'div',
  addAttributes: undefined
};
DOMSanitizer.propTypes = {
  children: node,
  element: string,
  addAttributes: arrayOf(string)
};
DOMSanitizer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DOMSanitizer",
  "props": {
    "element": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "addAttributes": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    }
  }
};
export default DOMSanitizer;